import PropTypes from "prop-types";
import React, { Component } from "react";
import { Message } from "../Message";
import Button from "@material-ui/core/Button/index";
import Icon from "@material-ui/core/Icon/index";
import { Trans } from "@lingui/macro";
import { connect } from "react-redux";
import { setReturnedValue } from "../../actions";
//import SearchAppointment from "./SearchAppointment";

class NoAppointment extends Component {
  state = {
    open: false
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  fullSearch = () => {
    this.props.setReturnedValue({
      fullSearch: "all",
      day: 7,
      customWhen: 0,
      inWeeks: 1,
      fromMonth: 1
    });
    return this.props.getAvailableAppointment(this.props.appointmentMethod);
  };

  render() {
    const { step, isFullSearch } = this.props;
    return (
      <div className="appointment">
        <div className="warning">
          {step.message && <Message step={step} />}
          {!isFullSearch && (
            <Button
              variant="contained"
              color="secondary"
              onClick={this.fullSearch}
            >
              <Trans id={"W_RECHERCHE_ETENDUE"} />
              <Icon>search</Icon>
            </Button>
          )}
        </div>
      </div>
    );
  }
}

NoAppointment.propTypes = {
  appointmentMethod: PropTypes.any,
  getAvailableAppointment: PropTypes.func,
  isFullSearch: PropTypes.bool,
  setReturnedValue: PropTypes.func,
  step: PropTypes.shape({
    message: PropTypes.any
  })
};

const mapStateToProps = state => {
  return {
    isFullSearch: state.returnedValue.fullSearch === "all",
    appointmentMethod: state.fetcher.appointmentMethod
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAvailableAppointment: appointmentMethod => dispatch(appointmentMethod()),
    setReturnedValue: value => dispatch(setReturnedValue(value))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoAppointment);
